import { useRef } from 'react';
import { useReportStore } from '@/entities/report';

/**
 * Supplies the HR summary tab with the report identifiers, recording window and ECG data map it renders from. Destructures profileId, studyId, timezone offset and the report start and stop out of the store's report info, reads the ECG data map, and holds an imperative ref to the HR chart used by the arrow-button handler.
 *
 * @returns The profile and study ids, timezone offset, report start and stop, the ECG data map, the chart ref and the arrow-button handler.
 */
const useHrSummary = () => {
  // reportInfoState (Recoil, Task 7) is typed {} | IReportInfo (atom default is {}) - pre-existing gap.
  const { profileId, studyId, timezoneOffset, startReport, stopReport } = useReportStore(
    (s) => s.reportInfo,
  ) as any;
  const ecgDataMap = useReportStore((s) => s.ecgDataMap);

  const hrChartRef = useRef<any>(null);

  /**
   * Steps the heart-rate chart to the neighbouring window when an arrow button is pressed. Delegates to the chart component through its imperative ref, doing nothing while the ref is unset.
   *
   * @param isNext - True to advance forward in time, false to step backwards.
   * @returns Nothing.
   */
  const handleClickArrowButton = (isNext = false) => {
    if (hrChartRef.current) {
      hrChartRef.current.handleClickArrowButton(isNext);
    }
  };

  return {
    profileId,
    studyId,
    timezoneOffset,
    startReport,
    stopReport,
    ecgDataMap,
    hrChartRef,
    handleClickArrowButton,
  };
};

export default useHrSummary;
